import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

const BengkelPage = () => (
<Home>
<Seo title="Aplikasi bengkel" />
<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/bengkel/">Aplikasi Bengkel</a></strong></h1>
<h2>Solusi untuk pembukuan dan penjualan service bengkel sparepart</h2>
<p>Fokus untuk usaha dan bisnis jenis layanan perawatan dan service kendaraan, bengkel menjadi lebih sempurna dengan penggunaan aplikasi bengkel dalam diterapkan, selain kemudahan dalam mencatat pembukuan , stok persediaan barang, alur service kendaraan , status kendaraan lengkap dengan nopol kendaraan pelanggan, penjualan jasa service dan spare part, penjualan point of sale untuk dan khusus kebutuhan part kepada pelanggan, hingga rangkuman laporan laporan detail plus dukungan kemudahan cek status kendaraan pada web app menjadikan kesempurnaan dalam menggunakan aplikasi bengkel dalam bekerja.</p>
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Cover</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo</button>
  </li>
</ul>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">

<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
  <StaticImage
src="../img/bengkelapp.webp"
className="img-fluid rounded shadow"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="aplikasi bengkel"
/>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/nD4A3WKH5yI" title="Aplikasi bengkel"></iframe>
</div>
  </div>

  </div>
  

</div>

</div>
</div>
</Home>
)

export default BengkelPage